import { CharacterDTO } from '../schemas';
import { Character } from '../types';

/**
 * Maps a CharacterDTO to the domain Character model.
 */
export function mapCharacterDTOToDomain(dto: CharacterDTO): Character {
  const { details, ...character } = dto

  return {
    ...details,
    ...character,
    id: dto.id || '', // Ensure ID is present
  };
}

/**
 * Maps an array of CharacterDTOs to domain Characters.
 */
export function mapCharactersDTOToDomain(dtos: CharacterDTO[]): Character[] {
  return dtos.map(mapCharacterDTOToDomain);
}
